import { render } from "./StudentProfile.vue?vue&type=template&id=2e48a412&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=2e48a412&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e48a412"]])

export default __exports__